import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock";

const Testimonials = () => {
  return (
    <section id="stories" className="py-14 md:py-24 bg-[#0a0f1c]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center text-red-400 text-[11.5px] tracking-[0.22em] uppercase font-medium">
          Student Success Stories
        </div>
        <h2 className="mt-3 text-center text-white text-[34px] md:text-[44px] font-semibold leading-[1.1] tracking-tight">
          8,000+ dreams fulfilled.{" "}
          <span className="text-amber-400">Yours could be next.</span>
        </h2>
        <div className="mt-5 flex items-center justify-center gap-3 text-slate-300">
          <div className="flex items-center gap-1 text-amber-400">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} className="h-4 w-4 fill-current" />
            ))}
          </div>
          <span className="text-[13.5px]">
            <span className="text-white font-semibold">4.9</span> average
          </span>
          <span className="text-slate-600">·</span>
          <span className="text-[13.5px]">1500+ verified reviews</span>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t) => (
            <div
              key={t.name}
              className="rounded-2xl cc-card p-6 flex flex-col transition-transform duration-300 hover:-translate-y-1"
            >
              <Quote className="h-6 w-6 text-amber-400/70" />
              <p className="mt-3 text-slate-200 text-[14.5px] leading-[1.7]">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-white/5">
                <div className="h-10 w-10 rounded-full bg-gradient-to-br from-amber-500 to-red-500 text-white grid place-items-center font-semibold text-[13px]">
                  {t.initials}
                </div>
                <div className="min-w-0">
                  <div className="text-white text-[14.5px] font-semibold leading-tight">{t.name}</div>
                  <div className="mt-0.5 text-slate-400 text-[12.5px] truncate">{t.meta}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
